interface CircleTrackerProps {
  colorStatus: string;
}

export const CircleTracker: React.FC<CircleTrackerProps> = ({
  colorStatus,
}) => {
  return (
    <div
      data-testid="circle-tracker"
      style={{
        width: '1rem',
        height: '1rem',
        borderRadius: '50%',
        backgroundColor: colorStatus,
        marginRight: '1rem',
        marginTop: '4px',
      }}
    />
  );
};
